/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_sidebar_menu_payment_links = /** @type {(inputs: {}) => string} */ () => {
	return `Link de Pago`
};

const en_sidebar_menu_payment_links = /** @type {(inputs: {}) => string} */ () => {
	return `Payment Link`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sidebar_menu_payment_links = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sidebar_menu_payment_links(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sidebar_menu_payment_links", locale)
	if (locale === "es") return es_sidebar_menu_payment_links(inputs)
	return en_sidebar_menu_payment_links(inputs)
};
export { sidebar_menu_payment_links as "sidebar.menu.payment_links" }